<template>
  <div class="sa-rep-filters">
    <div class="sa-rep-filters__toolbar">
      <div class="sa-rep-filters__field">
        <label :for="ids.system">Sistema</label>
        <select
          :id="ids.system"
          class="sa-rep-filters__control"
          :value="filters.typeSystem"
          @change="patch({ typeSystem: $event.target.value })"
        >
          <option value="">Todos</option>
          <option value="1">Weeduc</option>
          <option value="2">Weflix</option>
        </select>
      </div>

      <div class="sa-rep-filters__field">
        <label :for="ids.type">Tipo de empresa</label>
        <select
          :id="ids.type"
          class="sa-rep-filters__control"
          :value="filters.typeBusiness"
          :disabled="filters.typeSystem === '2'"
          @change="patch({ typeBusiness: $event.target.value })"
        >
          <option value="">Todos</option>
          <option value="1">Escolar</option>
          <option value="2">Corporativo</option>
        </select>
      </div>

      <div class="sa-rep-filters__field sa-rep-filters__field--search">
        <label :for="ids.search">Buscar empresa</label>
        <div class="sa-rep-filters__search">
          <fa icon="fa-magnifying-glass" class="sa-rep-filters__search-icon" aria-hidden="true" />
          <input
            :id="ids.search"
            type="search"
            class="sa-rep-filters__control sa-rep-filters__control--search"
            :value="filters.search"
            placeholder="Buscar empresa..."
            autocomplete="off"
            @input="patch({ search: $event.target.value })"
          />
        </div>
      </div>

      <div v-if="showPeriod" class="sa-rep-filters__field">
        <label :for="ids.period">Período</label>
        <input
          :id="ids.period"
          type="month"
          class="sa-rep-filters__control"
          :value="filters.period"
          @input="patch({ period: $event.target.value })"
        />
      </div>

      <div class="sa-rep-filters__actions">
        <button
          type="button"
          class="sa-rep-filters__clear"
          :disabled="!hasActiveFilters"
          @click="$emit('clear')"
        >
          Limpar filtros
        </button>
      </div>
    </div>

    <div v-if="activeChips.length" class="sa-rep-filters__chips" aria-label="Filtros ativos">
      <span class="sa-rep-filters__chips-label">Filtros:</span>
      <button
        v-for="chip in activeChips"
        :key="chip.key"
        type="button"
        class="sa-rep-filters__chip"
        @click="$emit('remove-chip', chip.key)"
      >
        {{ chip.label }}
        <span aria-hidden="true">×</span>
      </button>
      <button type="button" class="sa-rep-filters__clear-all" @click="$emit('clear')">
        Limpar tudo
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportsFilters',
  props: {
    filters: { type: Object, required: true },
    showPeriod: { type: Boolean, default: false },
    activeChips: { type: Array, default: () => [] },
    hasActiveFilters: { type: Boolean, default: false },
  },
  emits: ['update:filters', 'clear', 'remove-chip'],
  data() {
    const uid = Math.random().toString(36).slice(2, 8);
    return {
      ids: {
        system: `rep-system-${uid}`,
        type: `rep-type-${uid}`,
        search: `rep-search-${uid}`,
        period: `rep-period-${uid}`,
      },
    };
  },
  methods: {
    patch(partial) {
      this.$emit('update:filters', { ...this.filters, ...partial });
    },
  },
};
</script>

<style scoped>
.sa-rep-filters {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  text-align: left;
}

.sa-rep-filters__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  background: #f8f9fc;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 12px;
}

.sa-rep-filters__field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.3rem;
  min-width: 140px;
  text-align: left;
}

.sa-rep-filters__field--search {
  flex: 1 1 220px;
  min-width: 200px;
}

.sa-rep-filters__field label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--dashboard-muted, #697386);
  text-align: left;
}

.sa-rep-filters__control {
  height: 42px;
  width: 100%;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  border-radius: 9px;
  background: #fff;
  padding: 0 0.75rem;
  font-size: 0.875rem;
  color: var(--dashboard-text, #191c24);
  font-family: inherit;
  text-align: left;
}

.sa-rep-filters__control:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f3f4f8;
}

.sa-rep-filters__control:focus-visible {
  outline: 2px solid var(--dashboard-primary, #250891);
  outline-offset: 1px;
}

.sa-rep-filters__search {
  position: relative;
}

.sa-rep-filters__search-icon {
  position: absolute;
  left: 0.9rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--dashboard-muted, #697386);
  width: 0.9rem;
  height: 0.9rem;
  pointer-events: none;
}

.sa-rep-filters__control--search {
  width: 100%;
  padding-left: 2.85rem;
}

.sa-rep-filters__actions {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
}

.sa-rep-filters__clear,
.sa-rep-filters__clear-all {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--dashboard-primary, #250891);
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.55rem 0.25rem;
  height: 42px;
  text-align: left;
  white-space: nowrap;
}

.sa-rep-filters__clear:disabled {
  color: #a0a6b4;
  cursor: not-allowed;
}

.sa-rep-filters__clear:focus-visible,
.sa-rep-filters__clear-all:focus-visible,
.sa-rep-filters__chip:focus-visible {
  outline: 2px solid var(--dashboard-primary, #250891);
  outline-offset: 2px;
}

.sa-rep-filters__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}

.sa-rep-filters__chips-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--dashboard-muted, #697386);
}

.sa-rep-filters__chip {
  appearance: none;
  border: 1px solid var(--dashboard-border, #e8eaf0);
  background: #fff;
  color: var(--dashboard-text, #191c24);
  border-radius: 999px;
  padding: 0.28rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.sa-rep-filters__chip:hover {
  background: #f3f4f8;
}

@media (max-width: 768px) {
  .sa-rep-filters__actions {
    margin-left: 0;
    width: 100%;
  }

  .sa-rep-filters__field {
    flex: 1 1 calc(50% - 0.75rem);
  }

  .sa-rep-filters__field--search {
    flex: 1 1 100%;
  }
}

@media (max-width: 560px) {
  .sa-rep-filters__field {
    flex: 1 1 100%;
  }
}
</style>
